import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { InicialComponent } from './inicial/inicial.component';
import { AuthGuard } from './auth.guard';
import { EsqueciSenhaComponent } from './esqueci-senha/esqueci-senha.component';
const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'inicial', component: InicialComponent, canActivate: [AuthGuard] },
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
